export default "__VITE_ASSET__I41xuxWh__"